import router from 'next/router'
import React, { Fragment, useState } from 'react'
import { classNames } from 'utils/dom-helpers'
import { Menu, Transition } from '@headlessui/react'
import Translation from 'components/Translation'
import { useTenantContext } from 'context/TenantContext'
import { default_primary_color } from 'context/AuthContext'

const MENUS = [
    { id: '0', title: 'booking_page.home', icon: 'feather-home', link: '/book' },
    { id: '1', title: 'booking_page.my_bookings', icon: 'feather-layout', link: '/book/client/appointments' },
    { id: '2', title: 'booking_page.my_memberships', icon: 'feather-shopping-bag', link: '/book/client/memberships' },
    { id: '3', title: 'booking_page.profile', icon: 'feather-user', link: '/book/client/profile' },
    { id: '4', title: 'booking_page.book', icon: 'feather-calendar', link: '/book/appointments', alt_link: '/book/classes' },
]

const SUB_MENUS = [
    { id: '0', title: 'booking_page.book_a_class', icon: 'feather-users', link: '/book/classes' },
    { id: '1', title: 'booking_page.book_an_appointment', icon: 'feather-layout', link: '/book/appointments' },
]

const unselected_color = "#6b7280"

function MobileNavBar() {
    const [showDropdown, toggleShowDropdown] = useState<boolean>(false)
    const { primaryColor } = useTenantContext()
    const primary_color = primaryColor || default_primary_color

    return (
        <div className="fixed sm:hidden bottom-0 right-0 h-20 w-full pointer-events-none z-20 123">
            <Menu
                as="div"
                className="relative h-full"
            >
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                    show={showDropdown}
                >
                    <Menu.Items
                        static
                        className={classNames(
                            'origin-bottom-right bottom-[150%] right-[4%]',
                            'absolute flex flex-col mb-4 gap-y-3',
                            'focus:outline-none'
                        )}
                    >
                        {SUB_MENUS.map((sub_menu) => {
                            return (
                                <Menu.Item key={sub_menu.id} >
                                    <button
                                        className="rounded-full h-12 w-12 flex-row pointer-events-auto relative"
                                        style={{
                                            backgroundColor: primary_color
                                        }}
                                        onClick={() => {
                                            router.replace({
                                                pathname: sub_menu.link,
                                                query: router.query,
                                            })
                                            toggleShowDropdown(false)
                                        }}
                                    >
                                        <Translation
                                            render_as="label"
                                            content_key={sub_menu.title}
                                            className="absolute w-max right-[120%] text-[11px] text-white text-right rounded-lg px-2"
                                            style={{
                                                backgroundColor: primary_color
                                            }}
                                        />
                                        <i className={classNames("relative feather-calendar text-white m-auto", sub_menu.icon)} />
                                    </button>
                                </Menu.Item>
                            )
                        })}
                    </Menu.Items>
                </Transition>
                <nav className="z-20 w-full bg-white sticky bottom-0 h-20 flex pointer-events-auto"
                    style={{
                        boxShadow: "0px -3px rgb(209, 213, 219, 0.1)"
                    }}
                >
                    <div className="flex flex-row flex-auto px-1.5">
                        {MENUS.map((menu) => {
                            return (
                                <button
                                    key={menu.id}
                                    className={classNames("flex flex-auto w-full relative",
                                        menu.id == '4' ? "h-28 -mt-8" : "h-20"
                                    )}
                                    onClick={() => {
                                        if (menu.id != '4') {
                                            router.replace({
                                                pathname: menu.link,
                                                query: router.query,
                                            })
                                        } else {
                                            toggleShowDropdown(!showDropdown)
                                        }

                                    }}
                                >
                                    <div className={classNames("flex flex-col w-full h-full")}
                                        style={{
                                            color: router.pathname  == menu.link
                                                || (menu?.alt_link && router.pathname  == menu.alt_link)
                                                ? primary_color
                                                : unselected_color
                                        }}
                                    >
                                        {menu.id != '4' ? (
                                            <i className={classNames(menu.icon, "mx-auto mb-0 mt-4 block text-[28px]")}
                                            />
                                        ) : (
                                            <div className="mx-auto rounded-full w-16 h-16 mb-3 text-white relative"
                                                style={{
                                                    backgroundColor: primary_color
                                                }}
                                            > {/*dev note: if someone figures out a better way to do this, please fix*/}
                                                <i className={classNames(menu.icon, "relative mt-auto text-[34px] leading-[60px]")} />
                                            </div>

                                        )}

                                        <span className={classNames("text-[2.2vw] font-[450] mx-auto mb-auto")}
                                        >
                                            <Translation
                                                content_key={menu.title}
                                            /></span>
                                        <div className={classNames("bottom-0 h-0.5 w-full")}
                                            style={{
                                                backgroundColor: router.pathname  == menu.link
                                                    || (menu?.alt_link && router.pathname  == menu.alt_link)
                                                    ? primary_color
                                                    : 'inherit'
                                            }}
                                        >
                                        </div>
                                    </div>
                                </button>
                            )
                        })}
                    </div>
                </nav>
            </Menu>
        </div>

    )
}

export default MobileNavBar
